export default __webpack_public_path__ + "static/media/Checklist-orange.1ac4cb0f.svg";